
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { Grid, InputAdornment } from '@mui/material'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useTranslation } from 'react-i18next';
import { aiHighlightSx, aiIconSx } from '../styles/CommonStyles';

const styles = {
    customFieldsBox: {
        backgroundColor: '#FFFFFF',
        mt: 1
    },
    selectText: {
        textAlign: 'left'
    },
    menuItem: {
        justifyContent: 'flex-start'
    }
}

export default function CustomFieldDropDown(props: any) {
    const { index, customField, updateCustomFieldSubmitValues, customFieldDropDownValues, customFieldSubmitValues, isAiPopulated } = props
    const { t } = useTranslation();

    var selectedOptions = customFieldDropDownValues.map((item: any, i: any) => {
        if (item.customFieldID === customField.customFieldID) {
            return <MenuItem sx={styles.menuItem} key={i} value={item.value ?? ""}>{item.value}</MenuItem>
        } return null;
    })

    return (
        <Grid item md={11} xs={11} sx={styles.customFieldsBox}>
            <FormControl fullWidth>
                <TextField
                    select
                    label={customField.name}
                    value={customFieldSubmitValues['CustomFields']['Field'][index]['Value']}
                    size="small"
                    required={customField.required}
                    onChange={(element) => {
                        updateCustomFieldSubmitValues(index, element.target.value)
                    }}
                    SelectProps={{
                        sx: styles.selectText
                    }}
                    InputProps={isAiPopulated ? {
                        endAdornment: (
                            <InputAdornment position="end" sx={{ mr: 3 }}>
                                <AutoAwesomeIcon sx={aiIconSx} fontSize="small" />
                            </InputAdornment>
                        )
                    } : {}}
                    sx={isAiPopulated ? aiHighlightSx : {}}
                >
                    <MenuItem sx={styles.menuItem} value={""}><em>{t('control.inputs.customFields.none')}</em></MenuItem>
                    {selectedOptions}
                </TextField>
            </FormControl>
        </Grid>
    );
}